export const MAXALLOWEDFILES = 2;
export const FILE_TYPES = {
    png: 'image/png',
    jpg: 'image/jpg',
    jpeg: 'image/jpeg',
    pdf: 'application/pdf',
};
export const FILE_TYPES_ALLOWED = [FILE_TYPES.png, FILE_TYPES.jpg, FILE_TYPES.jpeg, FILE_TYPES.pdf].join(',');
